import * as Sentry from '@sentry/react';

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://7770a1e954294304b86072bf1d5a2d68@o4504610553790464.ingest.sentry.io/4505369135874048',
    integrations: [
      new Sentry.BrowserTracing({
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/pov\.stg\.acertusmarketplace\.io\/gql/, /^https:\/\/pov\.prd\.acertusmarketplace\.io\/gql/],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 100% of the transactions, reduce in production!
  });
};
